import {
  Card,
  CardContent,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from '@mui/material'
import React from 'react'

interface Props {
  title: string
  children: React.ReactNode
  minHeight?: number
  sx?: SxProps<Theme>
}

export default function ScenarioCard({
  title,
  children,
  minHeight = 280,
  sx,
}: Props) {
  const theme = useTheme()

  return (
    <Card
      variant="outlined"
      sx={{
        width: 340,
        flex: '0 0 340px',
        display: 'flex',
        flexDirection: 'column',
        minHeight,
        boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
        borderRadius: 1,
        border: '1px solid',
        borderColor: theme.palette.grey[200],
        padding: 0,
        ...sx,
      }}
    >
      <CardContent
        sx={{ display: 'flex', flexDirection: 'column', padding: '1rem' }}
      >
        <Typography variant="h6" color={theme.palette.primary.main}>
          {title}
        </Typography>
        {children}
      </CardContent>
    </Card>
  )
}
